import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProfileReview } from '../../models/ProfileReview.model';
import { ConfigurationService } from '@app/core/shell/services/configuration.service';

@Injectable({
    providedIn: 'root'
})
export class ProfilesService {

    constructor(private http: HttpClient, private configService: ConfigurationService) { }

    getReviewFields(userId: string) {
        const profilesApiUrl = this.configService.getConfig()?.shell.api.profilesApiUrl;

        // return this.http.get<ProfileReview>(`${profilesApiUrl}profiles/7ea04637-d53c-40e4-8556-13d2e40c1be3/reviewfields`);
        return this.http.get<ProfileReview>(`${profilesApiUrl}profiles/${userId}/reviewfields`);
    }

    delayProfileReview(userId: string) {
        const profilesApiUrl = this.configService.getConfig()?.shell.api.profilesApiUrl;
        // console.log(userId);
        // return this.http.put(`${profilesApiUrl}profiles/7ea04637-d53c-40e4-8556-13d2e40c1be3/delayreview`, undefined);
        return this.http.put(`${profilesApiUrl}profiles/${userId}/delayreview`, undefined);
    }

    updateProfile(userId: string, profile: any) {
        const profilesApiUrl = this.configService.getConfig()?.shell.api.profilesApiUrl;
        // console.log(userId);
        // console.log(profile);

        // return this.http.put(`${profilesApiUrl}profiles/7ea04637-d53c-40e4-8556-13d2e40c1be3/update/`, profile);
        return this.http.put(`${profilesApiUrl}profiles/${userId}/update/`, profile);
    }
}
